const px2vw = (size, width = 1440) => `${(size / width) * 100}vw`;
const px2vh = (size, width = 1440) => `${(size / width) * 100}vh`;
export default px2vw;
